import { FetchAPI } from '../Main/fetchAPI';
import { AddClientProperties, ClientPaginationProperties, UpdateClientInfoProperties } from './clientProperties';
import { CLIENTS } from '../constants';
import { CheckWeeklyHoursValidationProperties } from './userClientProperties';

export const Client = {
	checkWeeklyHoursValidation: ({
		clientId,
		userId,
		sessionTypeId,
		sessionDate,
		startTime,
		endTime,
	}: CheckWeeklyHoursValidationProperties) => {
		const query = new URLSearchParams();

		if (typeof sessionTypeId === 'number') query.set('sessionTypeId', `${sessionTypeId}`);
		if (sessionDate) query.set('sessionDate', sessionDate);
		if (startTime) query.set('startTime', startTime);
		if (endTime) query.set('endTime', endTime);

		return FetchAPI.getJson({
			urlStr: `${CLIENTS}/${clientId}/users/${userId}/weekly-hours-validation?${query.toString()}`,
		});
	},
	getClients: (data: ClientPaginationProperties) => {
		const { page, pageSize, direction, orderBy, searchString, status, caseCoordinatorId, branchId } = data;
		const query = new URLSearchParams();

		if (caseCoordinatorId) query.set('caseCoordinatorId', caseCoordinatorId);
		if (branchId) query.set('branchId', branchId);
		if (searchString) query.set('searchString', searchString);
		if (direction) query.set('direction', direction);
		if (orderBy) query.set('orderBy', orderBy);
		if (status) query.set('status', status);
		if (page) query.set('page', page);
		if (pageSize) query.set('pageSize', pageSize);

		return FetchAPI.getJson({
			urlStr: `${CLIENTS}?${query.toString()}`,
		});
	},
	addClient: (data: AddClientProperties) => {
		const { acknowledgeDuplicates, ...clientData } = data;
		const query = acknowledgeDuplicates ? '?acknowledgeDuplicates=true' : '';

		return FetchAPI.postJson({
			urlStr: `${CLIENTS}${query}`,
			data: clientData,
		});
	},
	getClientStatuses: () =>
		FetchAPI.getJson({
			urlStr: `${CLIENTS}/statuses`,
		}),
	getClient: (id: string) =>
		FetchAPI.getJson({
			urlStr: `${CLIENTS}/${id}`,
		}),
	updateClient: (data: UpdateClientInfoProperties) => {
		const { acknowledgeDuplicates, ...clientData } = data;
		const query = acknowledgeDuplicates ? '?acknowledgeDuplicates=true' : '';

		return FetchAPI.putJson({
			urlStr: `${CLIENTS}/${data.id}${query}`,
			data: clientData,
		});
	},
	deleteClient: (id: string) =>
		FetchAPI.deleteJson({
			urlStr: `${CLIENTS}/${id}`,
		}),
};
